<template>
  <div>
    <div class="row">
      <div class="col-md-4 mb-4">
        <info-card
          :title="'Contas a pagar Hoje'"
          icon="fa-calendar-day"
          variant="warning"
          :value="todayPayableTotal.sum_net_total"
        />
      </div>
      <div class="col-md-4 mb-4">
        <info-card
          :title="'Contas a pagar este mês'"
          icon="fa-calendar-day"
          variant="primary"
          :value="monthPayableTotal.sum_net_total"
        />
      </div>

      <div class="col-md-4 mb-4">
        <info-card
          :title="'Contas Atrasadas'"
          icon="fa-calendar-day"
          variant="danger"
          :value="overduePayableTotal.sum_net_total"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-4">
        <div class="card">
          <div class="card-body">
            <span class="text-muted">Contas a pagar</span>
            <hr />
            <bill-payable-historic-chart :data="PayableTotalByMonth" />
            <!-- <app-bar-chart :series="accountTransactionSeries" :categories="accountTransactionLabels"/> -->
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <table-paginator :data="PayableByVendor"  @pagechange="selectVendorRank($event)">
                  <span class="text-muted">Ranking de Fornecedores</span>
                  <hr />
                  <div class="row mb-4" v-for="(row, index) in PayableByVendor.data" :key="index">
                    <div class="col-6">
                      <template v-if="row.name != null">
                        <avatar
                          inline
                          color="#fff"
                          :size="30"
                          :username="row.name"
                          :initials="row.name.slice(0, 1)"
                        ></avatar>
                        <span style="margin-left:10px">{{ row.name }}</span>
                      </template>
                      <template v-else>
                        <avatar
                          inline
                          color="#fff"
                          :size="30"
                          :username="'Consumidor Final'"
                          :initials="'CF'"
                        ></avatar>
                        <span style="margin-left:10px">Fornecedor Não Indentificado</span>
                      </template>
                    </div>
                    <div class="col-6 text-right">{{ row.sum_net_total | decimal}}</div>
                  </div>
                </table-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <span class="text-muted">Em breve, mais indicadores...</span>
      </div>
    </div>
    <br />

    <error-handler :error="error" />
  </div>
</template>

<script>
import TablePaginator from "./../sections/TablePaginator.vue";
import InfoCard from "./../sections/dashboard/InfoCard.vue";
import AppBarChart from "./../ui/AppBarChart.vue";
import BillPayableHistoricChart from "./../charts/BillPayableHistoricChart.vue";
import Filter from "./../../mixins/Filters";
import Avatar from "vue-avatar";

export default {
  components: {
    TablePaginator,
    InfoCard,
    AppBarChart,
    BillPayableHistoricChart,
    Avatar
  },

  data: function() {
    return {
      series: [
        {
          data: []
        },
        {
          data: []
        }
      ],

      //labels : [2001, 2002, 2003, 2004, 2005, 2006, 2007],

      todayPayableTotal: {},

      monthPayableTotal: {},

      PayableTotalByMonth: {},

      PayableByVendor: {
          data: []
      },

      overduePayableTotal: {},

      orderBySalesman: {},
      // accountTransactionsOut : [],
      // accountTransactionsIn : [],

      error: null,

      orderTotalByMonth: {}
    };
  },

  created() {
    axios
      .post("api/dashboard/billpayable/select")
      .then(response => {
        this.todayPayableTotal = response.data.todayPayableTotal;
        this.monthPayableTotal = response.data.monthPayableTotal;
        this.PayableTotalByMonth = response.data.PayableTotalByMonth;
        this.overduePayableTotal = response.data.overduePayableTotal;
        this.PayableByVendor = response.data.PayableByVendor;




        this.$store.commit("pageHasLoaded");
      })
      .catch(error => {
        this.error = error;
        this.$store.commit("pageHasLoadedWithError", { error: error });
      });
  },

  computed: {
    accountTransactionSeries() {
      let series = [];
      let labels = [];

      series[0] = {};
      series[0].name = "Entradas";
      series[0].data = this.accountTransactionsIn.map(elem => elem.sum_value);

      series[1] = {};
      series[1].name = "Saidas";
      series[1].data = this.accountTransactionsOut.map(
        elem => elem.sum_value * -1
      );

      return series;
    },

    accountTransactionLabels() {
      let labelsIn = this.accountTransactionsOut.map(elem => elem.paid_at);
      return labelsIn;
    }
  },

  methods: {
    selectVendorRank(page = 1) {
      axios
        .post("api/dashboard/billpayable/listVendor?page=" + page)
        .then(response => {

          this.PayableByVendor = response.data;
          console.log(response.data)

          this.$store.commit("pageHasLoaded");
        })
        .catch(error => {
          this.error = error;
          this.$store.commit("pageHasLoadedWithError", { error: error });
        });
    },

    getAccountBalance(id) {
      if (this.accountsBalance[id] == null) {
        return 0;
      }
      return this.accountsBalance[id].balance;
    }
  }
};
</script>

<style>
</style>
